export default __webpack_public_path__ + "static/media/image.377cf0fe.png";